// extracted by mini-css-extract-plugin
export default {"root":"BackedBy_root__5-zQL","title":"BackedBy_title__qDo1E","marquee":"BackedBy_marquee__xKzcl","swiperItem":"BackedBy_swiperItem__LDfqC"};